module.exports = __webpack_public_path__ + "img/空教室.ccec50c8.svg";